import { render, staticRenderFns } from "./PostsTab.vue?vue&type=template&id=52e58806&scoped=true&"
import script from "./PostsTab.vue?vue&type=script&lang=js&"
export * from "./PostsTab.vue?vue&type=script&lang=js&"
import style0 from "./PostsTab.vue?vue&type=style&index=0&id=52e58806&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e58806",
  null
  
)

export default component.exports